import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Alert,
  Divider,
} from "@mui/material";
import { X, Warning } from "@phosphor-icons/react";
import React, { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import ANUploader from "elements/ANUploader";
import useANUploader from "hooks/utils/useANUploader";

export default function SendAttachmentDialog({ open, onClose, onSendFiles }) {
  if (!open) return null;
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
  const allowMultipleFiles = true;
  const { handleFileUpload, dropzoneFiles, handleFileDelete, setDropzoneFiles } =
    useANUploader(allowMultipleFiles);
  const hasOversizedFiles = dropzoneFiles.some((f) => f.file.size > MAX_FILE_SIZE);
  const hasErrors = dropzoneFiles.some((f) => f.errors);
  const hasFiles = dropzoneFiles.length > 0;
  const [isSending, setIsSending] = useState(false);

  const handleSendFiles = async () => {
    try {
      setIsSending(true);
      await onSendFiles(dropzoneFiles);
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      PaperProps={{
        sx: { maxWidth: '440px' }
      }}
    >
      <DialogTitle>
        Add Attachment
        <IconButton aria-label="close" onClick={onClose}>
          <X />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <ANUploader
          handleFileUpload={handleFileUpload}
          handleFileDelete={handleFileDelete}
          dropzoneFiles={dropzoneFiles}
          setDropzoneFiles={setDropzoneFiles}
          useDropzoneOptions={{ multiple: true }}
          dropZoneStyle={{ margin: 0 }}
          maxFileSize={MAX_FILE_SIZE}
        />
        <Alert severity="warning" icon={<Warning />} sx={{ mt: 4 }}>
          File size limits vary by mobile carrier. For best results, keep files under 1MB. Larger
          documents can be uploaded to the client&apos;s account instead.
        </Alert>
      </DialogContent>
      <Divider />

      {hasOversizedFiles && (
        <Typography
          variant="body2"
          color="error"
          sx={{ margin: "8px 24px 0 24px", textAlign: "center" }}
        >
          Individual files may not exceed 5mb.
        </Typography>
      )}
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          onClick={handleSendFiles}
          disabled={!hasFiles || hasErrors || hasOversizedFiles}
          loading={isSending}
        >
          Send Attachment
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
